export const AXIS_INDICATOR_SIZE = 100;

export const AXIS_INDICATOR_CAMERA_BOUNDS = 1.8;
export const AXIS_INDICATOR_CAMERA_NEAR = 0.1;
export const AXIS_INDICATOR_CAMERA_FAR = 10;
export const AXIS_INDICATOR_CAMERA_DISTANCE = 3;

export const AXIS_LENGTH = 1;
export const AXIS_HEAD_LENGTH = 0.2;
export const AXIS_HEAD_WIDTH = 0.1;
export const AXIS_SHAFT_RADIUS = 0.025;
export const AXIS_LABEL_OFFSET = 0.3;
export const AXIS_LABEL_SCALE = 0.4;
export const AXIS_CENTER_RADIUS = 0.06;

export const AXIS_LABEL_CANVAS_SIZE = 64;
export const AXIS_LABEL_FONT = 'bold 48px Arial';

export const AXIS_COLOR_X = 0xff4444;
export const AXIS_COLOR_Y = 0x44cc44;
export const AXIS_COLOR_Z = 0x4488ff;
export const AXIS_COLOR_CENTER = 0x888888;
